// extracted by mini-css-extract-plugin
var _1 = "FeedbackIcon_image__bc62e";
export { _1 as "image" }
